import type { LiveEvent } from '@setplex/tria-api'
import type { Store } from 'effector'

import { api } from '@setplex/tria-api'
import { genPagesLogic } from '~/shared/effector'

export const $liveEvents: Store<LiveEvent[]> = api.liveEvents.$liveEvents

export const loadMoreLiveEvents = genPagesLogic(
  api.liveEvents.$liveEventsPageInfo,
  api.liveEvents.loadLiveEventsFx
)
